import { ElementRef, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filenameSplice'
})
export class FilenameSplicePipe implements PipeTransform {

  transform(value: string, data: number | ElementRef = 0,type:'auto'|'manual'='manual'): unknown {

    let fileName = value.split('.');
    let extension = fileName[fileName.length-1];
     

    if(value.length < data) return value;

    if(type=='manual') {
      return value.substring(0, data as number) + '...' + extension;
    }
    else {
      // todo :: a auto splicer based data provided, usally data will be of type number 
      // but for type 'auto' it will send ElementRef and get the innerWidth and fit the size accordingly
      // ElementRef usually be parent element/container
      return value;
    }
  }

}

// ps, why didn't I use typeOf operator on data ? You can use that if you want to. 